import { render } from "./Octopus.vue?vue&type=template&id=7fc16cec"
import script from "./Octopus.vue?vue&type=script&lang=js"
export * from "./Octopus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__